import { useAuth } from "@/features/Auth/lib/useAuth";
import { useDashboard } from "@/features/Sale/Dashboard/lib/useDashboard";
import { useDashboardActions } from "@/features/Sale/Dashboard/lib/useDashboardActions";
import { getInitialBoolean } from "@/shared/lib/localStorage";
import { useEffect, useState } from "react";

const usePlanBody = (key: string, userId?: number | null, departmentId?: number) => {
  const { loading, error, dateStart, dateEnd, myPlanResult, userPlanResult, departmentPlanResult } = useDashboard();
  const { isAuth, user } = useAuth();
  const { getMyPlanResult, getUserPlanResult, getDepartmentPlanResult } = useDashboardActions();

  const myDepartmentId = user?.bx?.department?.[0]?.id;

  const [isPeriod, setIsPeriodState] = useState<boolean>(getInitialBoolean(key, false));

  useEffect(() => {
    localStorage.setItem(key, String(isPeriod));
    // eslint-disable-next-line
  }, [isPeriod]);

  const hasUserId = userId !== undefined && userId !== null;
  const hasDepartmentId = !hasUserId && departmentId !== undefined && departmentId !== null;

  const getResult = hasUserId
    ? getUserPlanResult
    : hasDepartmentId
      ? getDepartmentPlanResult
      : getMyPlanResult;

  const result = hasUserId
    ? userPlanResult
    : hasDepartmentId
      ? departmentPlanResult
      : myPlanResult;

  // Показываем "Нет планов" только когда планов действительно нет (нет целей), а не когда выполнение 0%
  let fullMessage: string | undefined = undefined;
  if (
    result &&
    result.opportunity &&
    result.profit &&
    (result.opportunity.target === 0 || result.opportunity.target == null) &&
    (result.profit.target === 0 || result.profit.target == null) &&
    Array.isArray(result.second) &&
    result.second.length === 0
  ) {
    fullMessage = 'Нет планов';
  }

  useEffect(() => {
    if (
      isAuth &&
      dateStart &&
      dateEnd &&
      (
        (hasUserId && userId !== undefined && userId !== null) ||
        (hasDepartmentId && departmentId !== undefined && departmentId !== null) ||
        (!hasUserId && !hasDepartmentId)
      )
    ) {
      const payloadDepartmentId = hasUserId
        ? departmentId ?? 0
        : hasDepartmentId
          ? departmentId!
          : (myDepartmentId ?? 0);
      getResult({
        dateStart,
        dateEnd,
        isPeriod,
        userId: userId ?? 0,
        departmentId: payloadDepartmentId,
      });
    }
    // eslint-disable-next-line
  }, [isAuth, dateStart, dateEnd, departmentId, userId, myDepartmentId]);

  return {
    loading: userId ? loading.dashboardUserPlanResult : (departmentId ? loading.dashboardDepartmentPlanResult : loading.dashboardMyPlanResult),
    error: userId ? error.dashboardUserPlanResult : (departmentId ? error.dashboardDepartmentPlanResult : error.dashboardMyPlanResult),
    result,
    res: result?.second,
    fullMessage,
    isPeriod, setIsPeriodState
  }
};

export default usePlanBody;